<template>
    <div class="device">
        <!-- <div class="search-bar">
            
        </div>     -->
        <div class="table-box">
            <el-row class="search-bar" :gutter="20">
                <div class="options-box">
                    <div class="options">
                        <div v-for="option in searchOptions" :key="option.key">
                            <div class="select-box" v-if="option.type === 'select'">
                                <span>{{option.label}}</span>
                                <el-select v-model="option.value" :placeholder="option.placeholder" class="input-width" clearable @change="searchSelectFn(option)">
                                    <el-option v-for="(selectOption,index)  in option.items" :key="'items'+index" :label="selectOption" :value="selectOption"></el-option>
                                </el-select>
                            </div>
                            <div class="input-box" v-if="option.type === 'input'">
                                <span>{{option.label}}</span>
                                <el-input maxlength="18" v-model="option.value" :placeholder="option.placeholder" class="input-width"></el-input>
                            </div>
                        </div>                        
                        <el-button type="primary" icon="el-icon-search" size="mini" @click="search">查询</el-button> 
                    </div>  
                </div>               
            </el-row>
            <el-button class="addBtn" type="primary" size="small" @click="addDevice">新增设备</el-button>
            <el-table :data="tableData"
                    v-loading="loading"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)" stripe style="width: 100%; font-size:14px">
                <el-table-column type="index" align="center" label="序号"></el-table-column>
                <el-table-column prop="device_sn" align="center" label="设备ID"></el-table-column>
                <el-table-column prop="equipmentbrand" align="center" label="设备品牌"></el-table-column>
                <el-table-column prop="t_eq_type" align="center" label="设备类型"></el-table-column>
                <el-table-column prop="eq_model" align="center" label="设备型号"></el-table-column>
                <el-table-column prop="service_user_total" align="center" label="服务用户数"></el-table-column>
                <el-table-column prop="survey_total" align="center" label="检测数据"></el-table-column>
                <el-table-column prop="source" align="center" label="设备来源"></el-table-column>
                <el-table-column fixed="right" align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button @click="handleAddUser(scope.row)" type="text" size="small">用户绑定</el-button>
                        <el-button @click="handleLog(scope.row)" type="text" size="small">操作记录</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-box">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 50]" :page-size="size"
                layout="total, sizes, prev, pager, next, jumper" :total="total" :size="size" :current-page="page">                
            </el-pagination>
            <el-button type="primary" size="mini">GO</el-button>
            <!-- <el-pagination background @current-change="handleCurrentChange" layout="prev, pager, next" :total="total" :size="size" :current-page="page"></el-pagination>                 -->
        </div>
        <el-dialog title="用户绑定" :visible.sync="deviceDialog" width="80%">
            <el-button class="addBtn" type="primary" size="small" @click="handleAddUserByPanel">添加用户</el-button>
            <el-table :data="serviceUserData"  stripe style="width: 100%; font-size:14px">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column prop="real_name" align="center" label="用户名称"></el-table-column>
                <el-table-column align="center" label="身份证号">
                    <template slot-scope="scope">
                        <span v-if="scope.row.id_card&&scope.row.id_card.length">{{scope.row.id_card.substring(0,8)+'******'+scope.row.id_card.substring(scope.row.id_card.length-4)}}</span>
                        <span v-else>--</span>                    
                    </template>
                </el-table-column>
                <el-table-column prop="check_code" align="center" label="用户编号" v-if="maxUsers > 1"></el-table-column>
                <el-table-column prop="bind_time" align="center" label="绑定时间"></el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button @click="handleUntying(scope.row)" type="text" size="small">解绑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination @current-change="handleCurrentChange_user" :page-sizes="[10, 20, 30, 40, 50]" :page-size="user_size"
                    layout="total, prev, pager, next" :total="user_total" :size="user_size" :current-page="user_page">                
                </el-pagination>
            </div>
        </el-dialog>
        <el-dialog title="添加用户" :visible.sync="userDialog" width="30%">
            <el-form ref="bindUserForm" :model="userForm" :rules="rules_user" label-width="80px" size="mini">
                <el-form-item label="用户姓名" prop="name">
                    <el-input type="text" maxlength="15" v-model="userForm.name"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" prop="idCard">
                    <el-input type="text" maxlength="18" v-model="userForm.idCard"></el-input>
                </el-form-item>
                <el-form-item label="用户编号" prop="code" v-if="maxUsers > 1">
                    <el-select style="width:100%" v-model="userForm.code" placeholder="请选择用户编号">
                        <el-option v-for="(item,index) in codeData" :key="'codeData'+index" :label="item" :value="item"> </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="add-user-btns">
                <el-button type="primary" plain @click="userDialog = false">取 消</el-button>
                <el-button type="primary" @click="addUserCommit">保 存</el-button>
            </div>
        </el-dialog>
        <el-dialog title="解绑提示" :visible.sync="untyingDialog" width="20%">
            <div class="confirm-untying">解绑后该用户将<br>不能直接通过本设备上传数据</div>
            <div class="add-user-btns">
                <el-button type="primary" plain @click="untyingDialog = false">取 消</el-button>
                <el-button type="primary" @click="untyingOk">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="操作记录" :visible.sync="logDialog" width="60%">
            <el-table :data="logListData" stripe style="width: 100%; font-size:14px">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column prop="op_admin" align="center" label="操作人"></el-table-column>
                <el-table-column prop="op_type" align="center" label="操作方式"></el-table-column>
                <el-table-column prop="username" align="center" label="用户"></el-table-column>
                <el-table-column prop="create_time" label="操作时间"></el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination @current-change="handleCurrentChange_log" :page-size="log_size"
                    layout="total, prev, pager, next" :total="log_total" :size="log_size" :current-page="log_page">                
                </el-pagination>
            </div>
        </el-dialog>
        <el-dialog title="新增设备" :visible.sync="addDiveceDialog" width="30%">
            <el-form ref="deviceForm" :model="deviceForm" label-width="80px" :rules="rules" size="mini">
                <el-form-item label="设备类型" prop="type">
                    <el-select style="width:100%" v-model="deviceForm.type" placeholder="请选择设备类型" @change="seledType">
                        <el-option v-for="(item,index) in typeData" :key="'typeData'+index" :label="item" :value="item"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备品牌" prop="brand">
                    <el-select style="width:100%" v-model="deviceForm.brand" placeholder="请选择设备品牌" @change="seledBrand">
                        <el-option v-for="(item,index) in brandData" :key="'brandData'+index" :label="item" :value="item"> </el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="设备型号" prop="model">
                    <el-select style="width:100%" v-model="deviceForm.model" placeholder="请选择设备型号">
                        <el-option v-for="(item,index) in modelData" :key="'modelData'+index" :label="item" :value="item"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备ID" prop="eq_code">
                    <el-input type="text" maxlength="30" v-model="deviceForm.eq_code"></el-input>
                </el-form-item>
            </el-form>
            <div class="add-user-btns">
                <el-button type="primary" plain @click="addDiveceDialog = false">取 消</el-button>
                <el-button type="primary" @click="addDeviceCommit">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import DeviceAPI from '@/model/api/devicemanage'
import { Promise } from 'q';
import { setTimeout } from 'timers';
export default {
    name: 'usermanage',
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                    picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                    }
                }],
                disabledDate(time) {
                    return time.getTime() > Date.now() - 8.64e6
                }
            },                      // 日期选择器设置-快捷选择、最大选择当日
            page: 1,                // 当前页
            size: 10,               // 当前每页条数
            total: 0,               // 总条数
            deviceDialog: false,    // 设备详情弹窗
            userDialog: false,      // 添加用户弹窗
            untyingDialog: false,   // 确定解绑弹窗
            logDialog: false,       // 操作记录弹窗
            addDiveceDialog: false, // 新增设备弹窗
            dateGroup:'',           // 搜索条件-添加时间
            // 设备绑定用户
            user_page: 1,           // 当前页
            user_size: 10,          // 当前每页条数
            user_total: 0,          // 总条数
            // 操作记录
            log_page: 1,           // 当前页
            log_size: 10,          // 当前每页条数
            log_total: 0,          // 总条数
            // 搜索条件
            searchOptions: [          
                {key: 'deviceType', label:'设备类型', placeholder: '全部', type: 'select', value: null, items:[]},
                {key: 'deviceBrand', label:'设备品牌', placeholder: '全部', type: 'select', value: null, items:[]},
                {key: 'deviceModel', label:'设备型号', placeholder: '全部', type: 'select', value: null, items:[]},
                {key: 'deviceId', label:'设备ID', placeholder: '请输入设备ID', type: 'input', value: null},            
            ],
            // 表单数据
            tableData:[],
            // 设备服务用户详情数据
            serviceUserData:[],
            // 操作记录数据
            logListData: [],
            userForm: {name:'',idCard:''},
            deviceForm: {},
            options: [],
            selDevice:'',
            eq_code: '',        // 当前设备编号
            untyingID: '',      // 解绑主键id

            brandData:[],       // 品牌数据
            typeData: [],       // 类型数据
            typeIds:[],         // 类型数据对应的id
            modelData:[],       // 型号数据
            codeData:[],        // 添加用户-获取的设备编号数据
            codeIds:[],         // 用户编号-对应id
            rules: {
                brand: [
                    { required: true, message: '请选择品牌', trigger: 'change' }
                ],
                type: [
                    { required: true, message: '请选择类型', trigger: 'change' }
                ],
                model: [
                    { required: true, message: '请选择型号', trigger: 'change' }
                ],
                eq_code: [
                    { required: true, message: '请输入设备ID', trigger: 'change' }
                ]
            },
            rules_user: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                idCard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请选择用户编号', trigger: 'change' }
                ]
            },
            loading:false,
            maxUsers: 0,
        }
    },
    watch:{
        // 连续解绑，关闭窗口后，刷新列表
        deviceDialog(val) {
            if(!val) {
                this.initGetList()
            }
        }
    },
    created() {
        this.initGetList()
        
        this.getTypeList()
    },
    methods: {
        // 获取类型
        getTypeList() {
            DeviceAPI.deviceType().then(res => {
                this.typeData = Object.values(res.data.data.list)
                this.typeIds = Object.keys(res.data.data.list)
                this.searchOptions[0].items = res.data.data.list
                return Promise.all([this.typeData,this.typeIds])
            }) 
        },
        // 选完类型
        seledType() {
            let idOfIndex = this.typeData.indexOf(this.deviceForm.type)
            this.getBrandByType(this.typeIds[idOfIndex])
        },
        // 根据类型获取品牌
        getBrandByType(id) {
            let params = {type:id}
            DeviceAPI.deviceBrand(params).then(res => {        
                this.brandData = res.data.data.list
                
            })
        },
        // 选完品牌
        seledBrand() {
            this.getModelList()
        },
        // 根据品牌、类型获取型号
        getModelList () {
            let idOfIndex = this.typeData.indexOf(this.deviceForm.type)
            let params = {type:this.typeIds[idOfIndex],brand:this.deviceForm.brand}
            DeviceAPI.deviceModel(params).then(res => {
                this.modelData = res.data.data.list
            })
        },
        // 获取列表
        initGetList() {
            let mId = this.typeData.indexOf(this.searchOptions[0].value)
            let mType = this.typeIds[mId]
            let params = {
                eq_brand: this.searchOptions[1].value,
                eq_model_code: this.searchOptions[2].value,                
                eq_type: mType ? mType : '',
                eq_id: this.searchOptions[3].value,
                p: this.page,
                size: this.size
            }
            for(let item in params) {
                if(!params[item]) {
                    delete params[item]
                }
            }
            this.loading = true
            // 10s后关闭 loading
            setTimeout(() => {
                this.loading = false
            },10000)
            DeviceAPI.getDeviceList(params).then(res => { 
                this.loading = false               
                this.tableData = res.data.data.list
                this.total = res.data.data.total
                return Promise.all([this.tableData,this.total])
            })
        },
        // 获取用户列表
        getUsersList() {
            let params = {
                eq_code: this.eq_code,
                p: this.user_page,
                size: this.user_size
            }
            
            DeviceAPI.deviceBindUsers(params).then(res => {
                this.serviceUserData = res.data.data.list
                this.user_total = res.data.data.total
                return Promise.all([this.serviceUserData,this.user_total])
            })
        },
        // 点击解绑
        handleUntying(row) {
            this.untyingDialog = true
            this.untyingID = row.id
        },
        // 确认解绑
        untyingOk() {
            let params = {
                id: this.untyingID
            }            
            DeviceAPI.userUnbindDevice(params).then(res => {
                if(res.data.success) {
                    this.untyingDialog = false
                    // this.deviceDialog = false
                    this.$message.success('解绑成功')
                    this.getUsersList()
                    // this.initGetList()
                }
            })
        },
        // 点击操作记录
        handleLog(row) {
            this.logDialog = true
            this.eq_code = row.device_sn
            this.getLogList()
        },
        // 操作记录列表
        getLogList() {
            let params = {
                eq_code: this.eq_code,
                p:this.log_page,
                size:this.log_size
            }
            DeviceAPI.deviceBindLog(params).then(res => {
                this.logListData = res.data.data.list
                this.log_total = res.data.data.total
                return Promise.all([this.logListData,this.log_total])
            })
        },
        // 点击新增设备
        addDevice() {
            this.addDiveceDialog = true 
            this.deviceForm = {}              
        },
        // 提交新增设备
        addDeviceCommit() {
            let deviceFormData = new FormData()
            if(this.deviceForm.brand) {
                deviceFormData.append('brand', this.deviceForm.brand)
            }
            if(this.deviceForm.type) {
                let mId = this.typeData.indexOf(this.deviceForm.type)
                let mType = this.typeIds[mId]
                deviceFormData.append('type', mType)
            }
            if(this.deviceForm.model) {
                deviceFormData.append('model', this.deviceForm.model)
            }
            if(this.deviceForm.eq_code) {
                deviceFormData.append('eq_code', this.deviceForm.eq_code)
            }
                        
            this.$refs['deviceForm'].validate((valid) => {
                if (valid) {
                    DeviceAPI.addDevice(deviceFormData).then(res => {
                        if(res.data.success) {
                            this.$message.success('添加设备成功')
                            this.addDiveceDialog = false
                            this.initGetList()
                        }                
                    })
                } else {
                    console.log('表单验证失败');
                    return false;
                }
            }) 
        },
        // 点击绑定用户
        handleAddUser(row) {
            this.deviceDialog = true
            this.eq_code = row.device_sn
            this.untyingID = row.id
            this.getUsersList()
            this.getDeviceCode(row.id)
            this.maxUsers = row.eq_max_bind_num
        },
        // 弹窗的添加用户
        handleAddUserByPanel() {
            this.userDialog = true
            this.userForm = {}
            this.getDeviceCode(this.untyingID)
        },
        // 获取设备编号
        getDeviceCode(mid) {
            let params = {
                eq_id: mid
            }
            DeviceAPI.deviceCode(params).then(res => {
                if(res.data.success) {
                    this.codeData = Object.values(res.data.data)
                    this.codeIds = Object.keys(res.data.data)
                }                
            })
        },
        // 添加用户提交
        addUserCommit() {
            const UserFormData = new FormData()
            if(this.eq_code) {
                UserFormData.append('eq_code', this.eq_code)
            } 
            if(this.userForm.name) {
                UserFormData.append('username', this.userForm.name)
            }
            if(this.userForm.idCard) {
                UserFormData.append('id_card', this.userForm.idCard)
            }
            
            if(this.userForm.code) {
                // 多用户-取键
                let mIndex = this.codeData.indexOf(this.userForm.code)
                let mKey = this.codeIds[mIndex]
                UserFormData.append('eq_real_code', mKey)
            }else{
                // 单用户
                UserFormData.append('eq_real_code', this.codeIds[0])
            }
            if(this.untyingID) {
                UserFormData.append('eq_id', this.untyingID)
            }
            
            this.$refs['bindUserForm'].validate((valid) => {
                if (valid) {
                    DeviceAPI.userBindDevice(UserFormData).then(res => {
                        if(res.data.success) {
                            this.userDialog = false
                            this.$message.success('添加用户成功')
                            this.getUsersList()
                            this.initGetList()
                        }
                    })
                } else {
                    console.log('表单验证失败');
                    return false;
                }
            }) 
            
        },
        // 点击搜索
        search() {
            this.initGetList()
        },
        // 分页改变
        handleCurrentChange(val) {
            this.page = val
            this.initGetList()
        },
        // size改变
        handleSizeChange(val) {
            this.size = val
            this.initGetList()
        },
        // 设备绑定用户-分页改变
        handleCurrentChange_user(val) {
            this.user_page = val
            this.getUsersList()
        },
        // 操作记录-分页改变
        handleCurrentChange_log(val) {
            this.log_page = val
            this.getLogList()
        },
        // 搜索条件-下拉框
        searchSelectFn(val) {
            if(val.key === 'deviceType') {
                
                if(val.value){
                    console.log(this.typeData)
                    console.log(this.typeIds)
                    let mId = this.typeData.indexOf(val.value)
                    this.searchOptions[0].value
                    let params = {
                        type: this.typeIds[mId]
                    }
                    DeviceAPI.deviceBrand(params).then(res => {
                        this.searchOptions[1].items = res.data.data.list
                    })
                }
                else{
                    this.searchOptions[1].value = null
                    this.searchOptions[1].items = []
                    this.searchOptions[2].value = null
                    this.searchOptions[2].items = []
                }
                
            }

            if(val.key === 'deviceBrand') {
                if(val.value) {
                    let mId = this.typeData.indexOf(this.searchOptions[0].value)
                    let params = {
                        brand: val.value,
                        type: this.typeIds[mId]
                    }
                    DeviceAPI.deviceModel(params).then(res => {
                        this.searchOptions[2].items = res.data.data.list
                    })
                }
                else{
                    this.searchOptions[2].value = null
                    this.searchOptions[2].items = []
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.device{
    background: #f1f2f7;
    padding: 10px;
    .search-bar{
        width: 100%;
        line-height: 50px;
        background: #fff;
        margin-bottom: 10px;
        border-radius: 5px;
        .options-box{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 0 20px; 
            .options{               
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                .select-box, .input-box{
                    white-space: nowrap;
                    margin-right: 20px;
                    span {
                        width: 70px;
                        text-align: right;
                        margin-right: 10px;
                    }
                }                
            } 
            .option-date-picker{
                display: flex;
                flex-direction: row;
                span{
                    width: 70px;
                    text-align: right;
                    margin-right: 5px;
                }
            } 
            .el-button{
                margin: 10px;
            }        
        }
        .input-width{
            width: 150px;
        }
    }
    .table-box{
        background: #fff;
        border-radius: 5px;
        .addBtn{
            margin: 10px;
        }
    }
    .pagination-box{
        margin: 20px 0;
        display: flex;
        justify-content: flex-end;
    }
    .el-dialog .el-dialog__header{
        background: #f1f2f7;
    }
    .add-user-btns{
        text-align: center
    }
    .confirm-untying{
        text-align: center;
        margin: 20px 0;
        width: 100%;
        color: #23313F;
    }
}
</style>
